

import { Component, OnInit, ViewChild ,AfterViewInit, ViewChildren} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

import { from, interval, Observable } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import { ClusterOptions, ClusterStyle } from '@agm/js-marker-clusterer/services/google-clusterer-types';
import { TravelMarker, TravelMarkerOptions, TravelData, TravelEvents, EventType } from 'travel-marker';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

import { PDFfile } from 'src/app/device/PDFfile';
import { Router } from '@angular/router';
import { TraslateService } from 'src/app/traslate.service';
import { HttpClient } from '@angular/common/http';
import { SelectionModel } from '@angular/cdk/collections';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import {GoogleMapsAPIWrapper} from '@agm/core';

declare var google: any;
export interface dataScore {
  name: string;
  x: number;
  y: number;
  z: number;
}

export interface PeriodicElementfilter {
  name: string;
  position: number;
  weight: number;
  weight1: number;
  weight2: number;
  pushed_at: Date;
  created_at: Date;
}

@Component({
  selector: 'app-user-conducteur-trajet',
  templateUrl: './user-conducteur-trajet.component.html',
  styleUrls: ['./user-conducteur-trajet.component.scss']
})
export class UserConducteurTrajetComponent implements OnInit {



  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  tableDataSource:any
 icon:any={  url: 'https://media0.giphy.com/media/5dUpIQwwiHn2wQh10Z/giphy.gif',  scaledSize: {  width: 50,  height: 50  }}
 iconStart:any={  url: 'https://play-lh.googleusercontent.com/m5NS39Zkz-_DiRFWFfEpKxeSQlFOZMD5wJFfqf9Y3r9toqqi3yqOy1c2rpoY162pHg76',  scaledSize: {  width: 50,  height: 50  }}
iconEnd:any={  url: 'https://cdn0.iconfinder.com/data/icons/online-shopping-57/106/map_route_end-512.png',  scaledSize: {  width: 60,  height: 60  }}

  collection:any =[];
  lengthpage: number=100;
  pageSizeOptions1: number[];
  pageNum: any ;
  manualPage: number =0;
 colormarker ="#1155cc"
  manualPage1: number;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25];
  pageSize1: any;
  pageSize: any = 10;
  index2:any=30
  selection = new SelectionModel<any>(true, []);
 selectedRow;
  selected : boolean;
  ItemSelected: any[];



  highlighted=false;
  selectedRowIndex: number = -1;

  displayedColumns = ["id","date","information","lieu", "vitesse_min","vitesse_moy","vitesse_max","duree","score"];
  dataSource = new MatTableDataSource();

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: '0px', y: '0px' };
  CodePostal: any;
  Nom:any;
  Groupe: any;



  myModel = true;

veh:boolean=true;
scr:boolean=true;
  typeMapIdSelect: any ='roadmap';
  tableDataSourceContact: any;
  locationData: any[];
  data: any;
  dataPosition: any;
  simulation: boolean =false;


  constructor(private _formBuilder: FormBuilder , private _snackBar: MatSnackBar ,public dialog: MatDialog , private fb: FormBuilder ,private http: HttpClient,public traslateService: TraslateService, private location: Location) {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  changeTypeMap(e){
      this.typeMapIdSelect =e
    }

  async ngOnInit(): Promise<void> {
    this.http.get<any>('http://my-json-server.typicode.com/Hafsabo/jsonserver/db').subscribe(data => {
      this.dataSource = new MatTableDataSource(data.posts);
      this.tableDataSource= data.posts;
      this.tableDataSourceContact= data.posts
      this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    })


    this.drawPath()
    this.clusterStyles = [
      {
          textColor: "#FFFFFF",
          url: "https://raw.githubusercontent.com/mikesaidani/marker-clusterer-plus/master/images/m1.png",
          height: 50,
          width: 50
      },
      {
          textColor: "#FFFFFF",
          url: "https://raw.githubusercontent.com/mikesaidani/marker-clusterer-plus/master/images/m2.png",
          height: 50,
          width: 50,
      }
  ];

  this.clusterOptions = {
      gridSize: 50,
      minimumClusterSize: 2,
      averageCenter: true,
      maxZoom: 30,
      styles: this.clusterStyles,
  }
  }

  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'item': item };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
  }

  onContextMenuAction1(item: any) {
    alert(`Click on Supprimer for ${item.name}`);
  }

  onContextMenuAction2(item: any) {
    alert(`Click on Modifier for ${item.name}`);
  }

  onContextMenuAction3(item: any) {
    alert(`Click on Activer/Désactiver for ${item.name}`);
  }

isAllSelected() {
  const numSelected = this.selection.selected?.length;
  const numRows = this.dataSource.data?.length;
  return numSelected === numRows;
}

 masterToggle() {

  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row =>{ this.selection.select(row); });
}
map: any;
searchBox: any;
onMouseOver(infoWindow, $event: google.maps.MouseEvent) {
  infoWindow.open();
}
onMouseOut(infoWindow, $event: MouseEvent) {
  infoWindow.close();
}
mapReady(event: any) {
  this.map = event;
  const input = document.getElementById('Map-Search');
  this.searchBox = new google.maps.places.SearchBox(input);
  this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('Settings'));
  this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('Profile'));
  this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
  this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(document.getElementById('Logout'));

  this.searchBox.addListener('places_changed', () => this.goToSearchedPlace());
}

goToSearchedPlace() {
  const places = this.searchBox.getPlaces();
  if (places.length === 0) {
  return;
  }
  const bounds = new google.maps.LatLngBounds();
  places.forEach((place) => {
  if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
  } else {
      bounds.extend(place.geometry.location);
  }
  });
  this.map.fitBounds(bounds);
}

checkboxLabel(row?: any): string {

  if (!row) {

    return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

  }
  this.ItemSelected = this.selection.selected
  return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

}

GetSelectedRow(row) {
  if(this.selectedRowIndex===row.id){
    this.selectedRowIndex=-1;
    this.selected=false;


  }else {

    this.selectedRow=row;
    this.selectedRowIndex=row.id;
    this.selected=true;
  }
}

applyFilter(event: Event) {
  this.dataSource =new MatTableDataSource(this.tableDataSource)

  const filterValue = (event.target as HTMLInputElement).value;
  this.dataSource.filter = filterValue.trim().toLowerCase();
}

ngAfterViewInit() {

  this.updateManualPage2(this.index2)

}

public updateManualPage2(index2) {

  this.collection=[]

  this.paginator.pageSize = index2

  this.paginator.page.next({
    pageIndex: this.paginator.pageIndex,
    pageSize: index2,
    length: this.paginator.length
  });


  this.lengthpage = parseInt(""+this.paginator.length/index2)

   //Create dummy data
   for (var i = 0; i < this.lengthpage+1; i++) {
    this.collection.push(i+1);
  }


  }

public updateManualPage(index): void {
  this.pageNum =index
  this.manualPage = index;
  this.paginator.pageIndex = index;

  this.paginator.page.next({
    pageIndex: this.paginator.pageIndex,
    pageSize: this.paginator.pageSize,
    length: this.paginator.length
  });


}

exportExcel(e ,e2) {
  Swal.fire({
    title: 'Souhaitez-vous  exporter la table ?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Start export file!',
    cancelButtonText: 'No, keep it'
  }).then((result) => {
    if (result.value) {
      Swal.fire(
        'Export!',
        'file is exported.',
        'success'
      )
      e.exportTable(e2,{fileName:'STG_DRIVE_conducteurs_date_'+new Date().toLocaleString() ,sheet: 'STG DRIVE conducteurs',Props:{'Author' :'STG_DRIVE'}})
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire(
        'Cancelled',
        'file not exported :)',
        'error'
      )
    }
  })

}

updateColor(progress) {
  if (progress > 75){
     return '#78C000';

  }
  else if (progress >= 55 ) {
    return  '#FD7F20';
  }
  else {
    return '#EB0000';
  }
}

clusterStyles: ClusterStyle[];
clusterOptions: ClusterOptions;
icon1:any = {
  url: 'http://earth.google.com/images/kml-icons/track-directional/track-4.png',
  scaledSize: {
    width: 30,
    height: 30
  }}

 zoom: any =17 ;
 openedWindow : number = 0;

 lat: number = 30.127371
 lng: number = -9.553743
 zoomPosition(e1,e2,e3 ,infoWindow ,$event: google.maps.MouseEvent){
   this.lat =e1
   this.lng =e2
   this.zoom =e3
   infoWindow.open();
 }

 openWindow(id) {
  if(this.selectedRowIndex===id){
    this.selectedRowIndex=-1;
    this.highlighted=false;

    this.openedWindow= -1;
  }else {
    this.highlighted=true;

    this.selectedRowIndex= id;
    this.openedWindow = id;

  }

}

isInfoWindowOpen(id) {
  return this.openedWindow == id;
}
 markers:marker[]=[];

 tmpPoints: marker[] = [
   {
     lat: 30.127371,
     lng: -9.553743,
     label: 'A',
     draggable: false
   },
   {
     lat: 30.127334,
     lng:  -9.553775,
     label: 'B',
     draggable: false
   },
   {
    lat: 30.127360,
    lng: -9.553795,
    label: 'C',
    draggable: false
  },
   {
     lat: 30.12719,
     lng: -9.553279,
     label: 'D',
     draggable: false
   },
   {
     lat: 30.12734,
     lng: -9.553289,
     label: 'D',
     draggable: false
   },
   {
     lat: 30.12747,
     lng: -9.553300,
     label: 'D',
     draggable: false
   },
   {
     lat: 30.12788,
     lng: -9.553400,
     label: 'D',
     draggable: false
   }
 ]

 calculateFunction(markers, numStyle: number){

  let index: number = 0
  let title: string = "ddfgdfg";
  let text: string = "<div style=\"position: relative; top: 2px; text-align: center; margin: 0px auto; width: 55px;\"> <div style=\"display: inline-block; width: 32px;\">{ELEMENTS}</div></div>";
  let qtdNodes: number = 0;
  let qtdEvents: number = 0;

  for(let i of markers){
      qtdNodes += i.zIndex;
      qtdEvents += i.zIndex;
  }

  index = (qtdEvents == 5) ? 1 : 2;

  text = text.replace( "{ELEMENTS}", qtdNodes.toString() );
  text = text.replace( "{PROBLEMS}", qtdEvents.toString() );

  return {
      text: text,
      index: index,

  }
 }
   arr = []

  drawPath(){

  this.markers.splice(0, this.markers.length);

  this.http.get<any>('http://my-json-server.typicode.com/Hafsabo/jsonserver/db').subscribe(data => {

      this.tableDataSource= data.posts;

      let i = 0;
  const obs =  interval(200).pipe(
    takeWhile((v) =>  i < this.tableDataSource.length))
    .subscribe(() => {
      const pos = this.tableDataSource[i].contact;
      var position:marker={
        lat:pos[0].lat,
	lng:pos[0].lng,
	label :"",
	draggable:null
      };


    var obj =  [pos[0].lat,pos[0].lng]

    this.arr.push(obj);

    this.traslateService.position.next(this.arr)

    this.arrayPosition(this.arr);
      this.markers.push(position);

      i++;
    } );

    })

}
arrayPosition(e){
this.dataPosition =e
}


// google maps zoom level
zoom1: number = 20;

// initial center position for the map
lat1: number = 51.512802;
lng1: number = -0.091324;


line: any;
directionsService: any;
marker: TravelMarker = null;

// speedMultiplier to control animation speed
speedMultiplier = 1;
  route: any;
  routeJSON: string;

onMapReady(map: any) {
  this.map = map;
  // this.calcRoute();
  this.mockDirections();
  // this.initEvents();

}

desactiveSimulation(){
  this.simulation =false;
}
 // mock directions api
 mockDirections() {
   this.simulation =true;
 this.locationData =this.dataPosition
  const locationArray = this.locationData.map(l => new google.maps.LatLng(l[0], l[1]));
  this.line = new google.maps.Polyline({
    strokeColor: "#4285f4",
    strokeOpacity: 0.9,
    path: "'FORWARD_CLOSED_ARROW'",
    map: this.map,
    icons: [{
      icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
      offset: '100%',
      repeat: '40px'
    }]
  });

  locationArray.forEach(l => {this.line.getPath().push(l);});
  const start = new google.maps.LatLng(30.127371, -9.553743);
  const end = new google.maps.LatLng(30.12789, -9.553405);


  const startMarker = new google.maps.Marker({position: start, map: this.map, icon :this.iconStart});
  const endMarker = new google.maps.Marker({position: end, map: this.map, icon :this.iconEnd});

  this.initRoute();
}

initRoute() {
  this.route = this.line.getPath().getArray();
this.routeJSON = JSON.stringify(this.route)
this.locationData.forEach(element => {
});

  const options: TravelMarkerOptions = {
    map: this.map,
    speed: 50,
    interval: 10,
    speedMultiplier: this.speedMultiplier,
    cameraOnMarker: true,
    markerType: 'overlay',
    markerOptions: {
      title: 'Travel Marker',
      animation: google.maps.Animation.DROP,
      icon: {
        url: 'https://i.imgur.com/eTYW75M.png',
        // This marker is 20 pixels wide by 32 pixels high.
        animation: google.maps.Animation.DROP,
        // size: new google.maps.Size(256, 256),
        scaledSize: new google.maps.Size(128, 128),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(53, 110)
      }
    },
  };

  // define marker
  this.marker = new TravelMarker(options);

  // add locations from direction service
  this.marker.addLocation(this.route);

  setTimeout(() => this.play(), 2000);
}
// play animation
play() {
  this.marker.play();
}

// pause animation
pause() {
  this.marker.pause();
}

// reset animation
reset() {
  this.marker.reset();
}

// jump to next location
next() {
  this.marker.next();
}

// jump to previous location
prev() {
  this.marker.prev();
}

// fast forward
fast() {
  this.speedMultiplier*=2;
  this.marker.setSpeedMultiplier(this.speedMultiplier);
}

// slow motion
slow() {
  this.speedMultiplier/=2;
  this.marker.setSpeedMultiplier(this.speedMultiplier)
}

initEvents() {
  this.marker.event.onEvent((event: EventType, data: TravelData) => {
  });
}
}
interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}
